import { useNavigate } from "react-router-dom";

const blogs = [
  {
    id: "3",
    title: "When 'Settled' Actually Means Settled: The New Rulebook for NPA Settlements",
    desc: "What every Bank, NBFC and Fintech need to know about the Supreme Court's landmark ruling.",
    tags: ["Collections Intelligence", "NPA Settlements"],
  },
  {
    id: "2",
    title: "The Clock Has Moved Forward. Your Collections Strategy Hasn't",
    desc: "Why RBI's 2025 Master Directions make early-stage collections the most important conversation in lending right now.",
    tags: ["India", "Debt Recovery"],
  },
  {
    id: "1",
    title: "International Debt Recovery Mechanisms and India's Emerging Framework",
    desc: "How UK, US, and Singapore are reshaping debt recovery.",
    tags: ["Comparative Study"],
  },
];

const BlogList = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white min-h-screen">
      <div className="max-w-7xl mx-auto px-4 md:px-12 py-14">
        
         <p className="text-[18px] font-bold tracking-[2px] uppercase text-[#686868] mb-2">
    Insights & Research
  </p>

        <div className="grid md:grid-cols-2 gap-6">
          {blogs.map((blog) => (
           <div
  key={blog.id}
  onClick={() => navigate(`/blogs/${blog.id}`)}
  className="group cursor-pointer rounded-2xl border border-[#E3E4F1] 
  bg-gradient-to-br from-white to-[#F8FAFF] 
  p-6 flex flex-col justify-between
  hover:shadow-xl hover:-translate-y-1 transition-all duration-300
  border-l-4 border-l-[#015CFD]"
>
  <div>
    <div className="flex gap-2 mb-3 flex-wrap">
      {blog.tags.map((tag, i) => (
        <span
          key={i}
          className="bg-[#EEF4FF] text-[#015CFD] text-[11px] px-3 py-1 rounded-full font-semibold"
        >
          {tag}
        </span>
      ))}
    </div>

    <h2 className="text-[18px] md:text-[20px] font-bold text-[#101010] mb-2 group-hover:text-[#015CFD] transition">
      {blog.title}
    </h2>
    <p className="text-[14px] text-[#686868] leading-relaxed mb-5">
      {blog.desc}
    </p>
  </div>

  {/* CTA */}
  <button
    onClick={(e) => {
      e.stopPropagation();
      navigate(`/blogs/${blog.id}`);
    }}
    className="flex items-center gap-2 text-[#015CFD] font-semibold text-sm mt-auto"
  >
    Read More
    <span className="group-hover:translate-x-1 transition">→</span>
  </button>
</div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default BlogList;